import tokens from "./tokens";

/**
 * Legacy color ramps, retuned onto the brand tokens (see tokens.ts).
 *
 * The ramp shape is kept because the theme and dozens of style modules
 * consume these slots. New code should read from `tokens` (or the MUI
 * theme palette) instead.
 */
export const COLORS = {
  white: "#fff",
  gray: {
    900: "#102226",
    800: tokens.colors.ink,
    700: "#2F464B",
    600: tokens.colors.inkSecondary,
    500: tokens.colors.inkMuted,
    400: tokens.colors.inkFaint,
    300: tokens.colors.borderStrong,
    200: tokens.colors.border,
    100: "#EAF1F1",
    50: tokens.colors.pageBg,
  },
  darkBlue: {
    500: tokens.colors.primaryDark,
    400: "#3C585D",
    300: tokens.colors.inkMuted,
    200: "#7F9193",
    100: "#A2B1B2",
    75: "#C5CFD0",
    50: "#E8EEEE",
  },
  blue: {
    500: tokens.colors.primary,
    400: "#56909A",
    300: "#74A3AC",
    200: "#92B7BE",
    100: "#AFCBCF",
    75: tokens.colors.primaryTint,
    50: tokens.colors.primarySoft,
  },
  green: {
    500: tokens.colors.success.fg,
    400: tokens.colors.success.main,
    300: "#4CA95E",
    200: "#9ADBA9",
    100: "#C4EACB",
    75: tokens.colors.success.bg,
    50: "#F0FAF2",
  },
  red: {
    500: tokens.colors.error.fg,
    400: "#D84665",
    300: "#DF6881",
    200: "#E6899D",
    100: tokens.colors.error.border,
    75: tokens.colors.error.bg,
    50: "#FCEEF1",
  },
  yellow: {
    500: tokens.colors.warning.main,
    400: "#E49900",
    300: "#EBB13D",
    200: "#F2CC70",
    100: "#F9E7BF",
    75: tokens.colors.warning.bg,
    50: "#FDF9EC",
    40: "#FDF6E1",
  },
  orange: {
    500: "#F76F34",
    400: "#FC733F",
    300: "#FC895E",
    200: "#FCB59B",
    100: "#FCD4C6",
    75: "#FCE4DB",
    50: "#FCF4F0",
  },
  messageLink: {
    main: tokens.colors.inkSecondary,
  },
  input: {
    normal: tokens.colors.border,
  },
  neutral: {
    main: tokens.colors.inkMuted,
  },
  primary: {
    main: tokens.colors.primary,
  },
  error: {
    main: tokens.colors.error.fg,
    contrastText: "#fff",
  },
  warning: {
    main: tokens.colors.warning.main,
    contrastText: "#fff",
  },
  success: {
    main: tokens.colors.success.fg,
    contrastText: "#fff",
  },
  info: {
    main: tokens.colors.info.fg,
    contrastText: "#fff",
  },
};

export interface ColorsInterface {
  white: string;
  gray: {
    900: string;
    800: string;
    700: string;
    600: string;
    500: string;
    400: string;
    300: string;
    200: string;
    100: string;
    50: string;
  };
  blue: {
    500: string;
    400: string;
    300: string;
    200: string;
    100: string;
    75: string;
    50: string;
  };
  darkBlue: {
    500: string;
    400: string;
    300: string;
    200: string;
    100: string;
    75: string;
    50: string;
  };
  green: {
    500: string;
    400: string;
    300: string;
    200: string;
    100: string;
    75: string;
    50: string;
  };
  red: {
    500: string;
    400: string;
    300: string;
    200: string;
    100: string;
    75: string;
    50: string;
  };
  yellow: {
    500: string;
    400: string;
    300: string;
    200: string;
    100: string;
    75: string;
    50: string;
    40: string;
  };
  orange: {
    500: string;
    400: string;
    300: string;
    200: string;
    100: string;
    75: string;
    50: string;
  };
  messageLink: {
    main: string;
  };
  input: {
    normal: string;
  };
  neutral: {
    main: string;
  };
}
